import react,{useState, useEffect,} from "react"

import 'semantic-ui-css/semantic.min.css'
import './welcomePage.css';
import MobileView from "./MobileView";
import WebView from './WebView';

function WelcomePage(props) {
  const [mobileview,setMobileview] = useState(true)

  useEffect(() => {
    if(window.innerWidth > 500){
      setMobileview(false)
    }
  }, [window.innerWidth])

  return (
    <>
    { mobileview ? <MobileView {...props}/> : <WebView {...props}/>}
    </>
  )

}

export default WelcomePage;
